import {createSelector} from 'reselect';
import {getActiveProduct} from 'selectors/product/product';
import {ApplicationStoreType} from 'reducers';
import {AddToCartType} from 'pages/cart/store/actions/addToCart/addToCartType';
import {getProductData, getWizardData} from 'features/wizardMs/selectors/addToCart/addToCart';
/**
 * Returns price of active product
 * @param {ProductPriceType} store - application store
 * @returns {ProductPriceType} price object
 */
export const getProductPrice = createSelector(getActiveProduct, ({price, finalPrice}): {
    price: number;
    finalPrice: number;
} => ({
    price,
    finalPrice,
}));

/**
 * Returns the final result of combine data to add or update cart
 * without prescription. It needs only for fetch discount price
 */
export const getAddAndUpdateCartDataForPrice = createSelector(
    getProductData,
    getWizardData,
    (productData, wizardData): AddToCartType => ({
        ...productData,
        ...wizardData,
    }),
);

/**
 * Returns the type of glasses
 * @param {ApplicationStoreType} store - application store
 * @returns {string} - type glasses
 */
export const getProductType = (store: ApplicationStoreType): string => store.product.type;
